import { computed, onUnmounted, ref } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import { AudioFileData, GlobalAudioPlayerData } from "../types";

export default function useGlobalAudioController() {
  const fileList = ref<AudioFileData[]>([]);
  const activeUuid = ref<string | null>(null);

  const activeFileIndex = computed(() => fileList.value?.findIndex(i => i.uuid === activeUuid.value) ?? -1);
  const activeFile = computed(() => (activeFileIndex.value > -1 ? fileList.value[activeFileIndex.value] : null));
  const hasPrev = computed(() => activeFileIndex.value > 0);
  const hasNext = computed(() => activeFileIndex.value > -1 && activeFileIndex.value < fileList.value.length - 1);

  const init = (data?: GlobalAudioPlayerData) => {
    if (!data) return;
    fileList.value = data.fileList;
    activeUuid.value = data.activeUuid;
  };

  const prev = () => {
    if (!hasPrev.value) return;
    activeUuid.value = fileList.value[activeFileIndex.value - 1].uuid;
  };

  const next = () => {
    if (!hasNext.value) return;
    activeUuid.value = fileList.value[activeFileIndex.value + 1].uuid;
  };

  const reset = () => {
    fileList.value = [];
  };

  emitter.on<GlobalAudioPlayerData>(EVENTS.AUDIO_PLAYER_INIT, init);
  emitter.on(EVENTS.AUDIO_PLAYER_RESET, reset);
  onUnmounted(() => {
    emitter.off<GlobalAudioPlayerData>(EVENTS.AUDIO_PLAYER_INIT, init);
    emitter.off(EVENTS.AUDIO_PLAYER_RESET, reset);
  });

  return {
    fileList,
    activeFile,
    hasPrev,
    hasNext,
    prev,
    next,
    reset,
  };
}
